import type { StyleSettings } from '@/types';
import { isLocalMode } from '@/local';
import { apiFetch } from './apiBase';
import { localGetStyleSettings, localPutStyleSettings } from '@/local/localBackend';

export async function getStyleSettings(episodeUuid: string): Promise<StyleSettings> {
  if (isLocalMode()) return localGetStyleSettings(episodeUuid);
  const res = await apiFetch(
    `/api/episode/${encodeURIComponent(episodeUuid)}/v2/style-settings`,
  );
  if (!res.ok) throw new Error(`getStyleSettings failed: ${res.status}`);
  return res.json();
}

export async function putStyleSettings(
  episodeUuid: string,
  settings: StyleSettings,
): Promise<StyleSettings> {
  if (isLocalMode()) return localPutStyleSettings(episodeUuid, settings);
  const res = await apiFetch(
    `/api/episode/${encodeURIComponent(episodeUuid)}/v2/style-settings`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(settings),
    },
  );
  if (!res.ok) throw new Error(`putStyleSettings failed: ${res.status}`);
  return res.json();
}
